import { BrowserRouter } from 'react-router-dom'
import { AuthContextProvider } from 'context/AuthContext'
import { ToastContainer } from 'react-toastify'

import RoutesApp from 'routes'
import { Device } from 'components/Device'

import 'react-toastify/dist/ReactToastify.css'
import 'antd/dist/antd.less'
import 'styles/global.scss'
import { FamilyProvider } from 'context/hooks/useFamily'
import { InactivityProvider } from 'context/hooks/useInactivity'
import { useAccessibility } from 'context/hooks/useAccessibility'
import { useMemo } from 'react'

function App() {
  const { contrastIsSelected } = useAccessibility()

  const styleContainer = useMemo(
    () => (contrastIsSelected ? 'container-app contrastMode' : 'container-app'),
    [contrastIsSelected]
  )

  return (
    <section className={styleContainer}>
      <Device>
        <BrowserRouter>
          <AuthContextProvider>
            <InactivityProvider>
              <FamilyProvider>
                <ToastContainer autoClose={3000} />
                <RoutesApp />
              </FamilyProvider>
            </InactivityProvider>
          </AuthContextProvider>
        </BrowserRouter>
      </Device>
    </section>
  )
}

export default App
